import { useMultipleQueryParamStates } from '#/hooks/useMultipleQueryParamStates';
import type { AppRoute } from '#/routing/classes/AppRoute';

export function useAppRouteSearchParams<
  T extends AppRoute<string, string, string>,
>(
  routePath: T,
): ReturnType<typeof useMultipleQueryParamStates<T['searchParams'][number]>> {
  return useMultipleQueryParamStates({
    names: routePath.searchParams,
    arrayNames: [],
  });
}
